<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Roles</div>
        <div>
          <bread-crumb :bread-crumbs="['Roles Summary']" />
        </div>
      </v-card-title>

      <v-data-table fixed-header  height="55vh"
        :headers="dessertHeaders"
        :items="RoleSummary"
        :search="search"
        dense
        item-key="name"
      >
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-btn
              text
              small
              color="primary"
              depressed
              class="mr-2"
              :to="`/EditRole/` + item.role_id + `/` + item.name"
            >
              Add privilages
            </v-btn>
            <v-icon
              small
              title="Edit"
              color="primary"
              class="mr-2"
              @click="editItem(item)"
            >
              mdi-content-save-edit-outline
            </v-icon>
            <v-icon
              small
              title="Delete"
              color="primary"
              class="mr-2"
              @click="deleteItem(item)"
            >
              mdi-trash-can-outline
            </v-icon>
          </div>
        </template>
        <template v-slot:item.is_two_factor_auth="{ item }">
          <v-switch
            v-model="item.is_two_factor_auth"
            height="0px"
            @click="updateTwoFactStatus(item)"
          >
          </v-switch>
        </template>
        <template v-slot:top>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <div class="d-flex mt-5">
            <v-btn
              depressed
              small
              class="text-capitalize me-2 ms-2 mt-2 text-decoration-none"
              color="primary"
              @click="openDialog()"
              ><v-icon small>mdi-plus</v-icon>Add Role</v-btn
            >
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              color="primary"
              small
              class="me-5 mt-2"
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-10"
              dense
              clearable
            ></v-text-field>
          </div>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="showDialog" width="500">
        <v-card>
          <v-form ref="Addform" v-model="valid">
            <v-toolbar color="secondary" dark flat dense>
              <span>{{ formtitle }} Role</span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Role Name
                  </label>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    placeholder="Role Name"
                    :rules="FieldRequired('Role Name')"
                    v-model="addRoleDetails.name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Description
                  </label>
                  <v-text-field
                    class="rounded"
                    dense
                    outlined
                    placeholder="Description"
                    :rules="FieldRequired('Description')"
                    v-model="addRoleDetails.description"
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="12" md="12">
                  <label class="my-0 rounded labelFontsize required">
                    Role Type
                  </label>
                  <v-autocomplete
                    class="rounded"
                    dense
                    outlined
                    placeholder="Role Type"
                    item-text="text"
                    item-value="values"
                    v-model="addRoleDetails.rule_type"
                  ></v-autocomplete>
                </v-col> -->
                <div
                  class="col-md-12"
                  style="display: flex; justify-content: right; margin-top: 8px"
                >
                  <v-btn
                    depressed
                    color="primary"
                    small
                    class="me-5 text-capitalize"
                    @click="onSubmitFor()"
                  >
                    <v-icon small class="me-2"
                      >mdi-content-save-plus-outline</v-icon
                    >Save
                  </v-btn>

                  <v-btn
                    depressed
                    color="primary"
                    small
                    class="text-capitalize"
                    outlined
                    @click="closeDialog()"
                  >
                    <v-icon small class="me-2">mdi-close-circle-outline</v-icon>
                    Cancel
                  </v-btn>
                </div>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <!-- delete dialog -->
      <v-dialog persistent v-model="dialogDelete" width="500">
        <v-card>
          <v-card-title class="border border-bottom">Delete</v-card-title>
          <v-card-text class="h5 py-3"
            >Are you sure you want to delete?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deleteItemConfirm"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="(dialogDelete = false), (deleteId = null)"
              ><v-icon>mdi-close</v-icon></v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import alerts from "@/mixins/alerts";
import userService from "@/services/UserService/userService.js";
import { FieldRequired } from "@/utils/validation.js";
export default {
  mixins: [alerts],
  name: "Roles Summary",
  data() {
    return {
      // expanded: [],
      FieldRequired,
      search: "",
      loader: false,
      showDialog: false,
      dialogDelete: false,
      deleteId: null,
      valid: true,
      editedIndex: -1,
      dessertHeaders: [
        {
          text: "Id",
          sortable: false,
          value: "role_id",
        },
        {
          text: "Role Name",
          value: "name",
        },
        { text: "Description", value: "description" },
        { text: "2FA Status", value: "is_two_factor_auth" },
        { text: "Created By", value: "created_by" },
        { text: "Updated By", value: "modified_by" },
        { text: "Action", value: "action", sortable: false },
      ],
      RoleSummary: [],
      addRoleDetails: {
        name: "",
        description: "",
        created_by: 0,
        created_date: "2023-11-23T07:02:39.582Z",
        is_active: true,
      },
    };
  },
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  mounted() {
    this.getRolesSummury();
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },
  methods: {
    async downloadExcelsheet() {
      if (this.RoleSummary) {
        this.exportToExcel(
          this.dessertHeaders,
          this.RoleSummary,
          "RoleSummary"
        );
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async updateTwoFactStatus(item) {
      this.loader = true;
      try {
        const responseData = await userService.updateRoletfaStatus({
          role_code: item.role_id,
          two_factor_enabled: item.is_two_factor_auth ? true : false,
        });
        if (responseData && responseData.data.status_code === 200) {
          this.stoploader();
          this.showAlertSuccess(responseData.data.message);
          this.getRolesSummury();
        } else {
          this.showAlertError(responseData.data.message);
          item.is_two_factor_auth = false;
          this.stoploader();
        }
      } catch (error) {
        console.log(error.response);
        this.showAlertError("Something went wrong please try again later.");
        this.loader = false;
        item.is_two_factor_auth = false;
      }
    },
    async getRolesSummury() {
      this.loader = true;
      try {
        const response = await userService.getAllRoles();
        if (response.data.status_code == 200) {
          this.RoleSummary = response.data.data.reverse();
        }
        this.stoploader();
        console.log("Roles", this.RoleSummary);
      } catch (e) {
        console.error(e);
        this.stoploader();
        this.showAlertError("Something went wrong please try again later.");
        this.RoleSummary = [];
      }
    },

    onSubmitFor() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        if (this.addRoleDetails.role_id) {
          this.update();
        } else {
          this.save();
        }
      }
    },

    async save() {
      this.loader = true;
      try {
        const response = await userService.addRoleData(this.addRoleDetails);
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.getRolesSummury();
          this.closeDialog();
          this.stoploader();
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.loader = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.loader = false;
        this.matchedsanctionsdata = [];
      }
    },
    async update() {
      this.loader = true;
      try {
        const response = await userService.updateRoleData(
          this.addRoleDetails.role_id,
          this.addRoleDetails
        );
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.closeDialog();
          this.getRolesSummury();
          this.stoploader();
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.loader = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.loader = false;
      }
    },
    deleteItem(item) {
      this.dialogDelete = true;
      this.deleteId = item.role_id;
    },

    async deleteItemConfirm() {
      this.loader = true;
      try {
        const response = await userService.deleteRole(this.deleteId);
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.dialogDelete = false;
          this.getRolesSummury();
          this.stoploader();
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.loader = false;
        }
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },

    navBranchList(item) {
      this.$router.push({
        name: "EditRole",
        params: { roles: item },
      });
    },

    openDialog() {
      this.editedIndex = -1;
      this.showDialog = true;
      this.addRoleDetails = {};
      this.addRoleDetails.is_active = true;
      if (this.$refs.Addform) {
        this.$refs.Addform.resetValidation();
      }
    },

    editItem(item) {
      this.editedIndex = 1;
      this.showDialog = true;
      this.addRoleDetails = item;
    },

    closeDialog() {
      this.showDialog = false;
      this.$refs.Addform.resetValidation();
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.width-anchor {
  width: 200px !important;
}

.required:after {
  content: " *";
  color: red;
}
</style>
